import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginNIE } from '../../redux/actions/auth';
import { useHistory } from 'react-router-dom';
import { getUrl, checkENV, appENV } from '../../components/Helpers/Config';
import { staticFiles } from '../../components/Helpers/Static';
import Cookies from 'js-cookie';

const LoginValidation = (props) => {
	const dispatch = useDispatch();
	const history = useHistory();
	const token = appENV === checkENV ? props.match.params.token : Cookies.get('token');
	// const token = props.match.params.token;
	const isLoading = useSelector(state => state.auth.isLoading)

	useState(() => {
		if (token && (token.length > 10)) {
			dispatch(loginNIE(token));
		}
	}, [token])

	if (!isLoading) history.push('/')

	return (
		<div className="w-full h-screen">
			<div className="h-full flex flex-col justify-center items-center">
				<img
					className="w-12"
					src={staticFiles.loading}
					alt='Loading'
				/>
				<h1 className="text-gray-600 mt-4">Logging in...</h1>
			</div>
		</div>
	)
}
// const mapDispatchToProps = (dispatch) => {
// 	return {
// 		getLoginToken : (param) => {
// 			dispatch({ type: GET_LOGIN_ACCESS_TOKEN, param});
// 		},  
// 	}
// }

// const mapStateToProps = (state) => { 
// 	return {
// 		loginToken : state.auth.token
// 	}
// }

// Index.propTypes = {
// history: PropTypes.shape({
// 	push: PropTypes.func.isRequired
// }) 
// };

// Index = connect(
// 	mapStateToProps,
// 	mapDispatchToProps,
// )(Index);

export default LoginValidation;